// @ds/connected/confirmContext — confirm context object + consumer hook.
//
// Split out of `ConfirmProvider.tsx` so that module exports components only.
import { createContext, useContext, type ReactNode } from "react";

export interface ConfirmOptions {
  titleKey: string;
  body?: ReactNode;
  okKey?: string;
  danger?: boolean;
}

export type ConfirmFn = (opts: ConfirmOptions) => Promise<boolean>;

export const ConfirmContext = createContext<ConfirmFn | null>(null);

const noopConfirm: ConfirmFn = async () => false;

/** Imperative confirm. Outside a `ConfirmProvider` (e.g. in unit tests) it
 *  resolves `false` so callers never throw. */
export function useConfirm(): ConfirmFn {
  return useContext(ConfirmContext) ?? noopConfirm;
}
